import Image from "next/image";
import React from "react";

interface Props {
  zIndex?: number;
  opacity?: string;
  children?: React.ReactNode;
  loaderImg?: string;
}

const Loader = ({
  zIndex = 999,
  opacity = "1",
  children = undefined,
  loaderImg = undefined,
}: Props) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[999999]"
      style={{ opacity, zIndex }}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        {loaderImg ? (
          <Image
            src={loaderImg}
            alt="loading spinner"
            height={80}
            width={80}
            className={`h-[80px] w-auto ${
              loaderImg && "rounded-full animate-spin"
            }`}
            quality={100}
            priority
          />
        ) : (
          <div
            className="loader-spinner"
            style={{
              width: "50px",
              height: "50px",
              aspectRatio: "1",
              display: "grid",
              mask: "conic-gradient(from 15deg, #0000, #000)",
              WebkitMask: "conic-gradient(from 15deg, #0000, #000)",
              animation: "s6 1s infinite steps(12)",
              background:
                "radial-gradient(closest-side at 50% 12.5%, rgb(var(--primary) / 1) 96%, #0000) 50% 0/20% 80% repeat-y, radial-gradient(closest-side at 12.5% 50%, rgb(var(--primary) / 1) 96%, #0000) 0 50%/80% 20% repeat-x",
            }}
          >
            <div
              style={{
                gridArea: "1/1",
                transform: "rotate(30deg)",
                background:
                  "radial-gradient(closest-side at 50% 12.5%, rgb(var(--primary) / 1) 96%, #0000) 50% 0/20% 80% repeat-y, radial-gradient(closest-side at 12.5% 50%, rgb(var(--primary) / 1) 96%, #0000) 0 50%/80% 20% repeat-x",
              }}
            ></div>
            <div
              style={{
                gridArea: "1/1",
                transform: "rotate(60deg)",
                background:
                  "radial-gradient(closest-side at 50% 12.5%, rgb(var(--primary) / 1) 96%, #0000) 50% 0/20% 80% repeat-y, radial-gradient(closest-side at 12.5% 50%, rgb(var(--primary) / 1) 96%, #0000) 0 50%/80% 20% repeat-x",
              }}
            ></div>
          </div>
        )}

        {children && <div className="text-center">{children}</div>}
      </div>
      <style jsx>{`
        @keyframes s6 {
          100% {
            transform: rotate(1turn);
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;
